import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AgentComponent } from './agent/agent.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AdminComponent } from './admin/admin.component';
import {RoutingModule} from './routing/routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {SharedModule} from './shared/shared.module';
import {DashboardModule} from './dashboard/dashboard.module';
import {AgentModule} from './agent/agent.module';
import {AdminModule} from './admin/admin.module';
import { DollarRateModule } from './dollar-rate/dollar-rate.module';
import { httpInterceptorProviders } from './shared/http-interceptors/index';
import { TransactionsComponent } from './transactions/transactions.component';
import {TransactionsModule} from './transactions/transactions.module';
import {StatModule} from './dashboard/stat/stat.module';
import { UiSwitchModule } from 'ngx-ui-switch';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastrModule} from 'ngx-toastr';
import {NgxPaginationModule} from 'ngx-pagination';
import { NotfoundComponent } from './notfound/notfound.component';
import { FundHistoryComponent } from './fund-history/fund-history.component';
import {FundHistoryModule} from './fund-history/fund-history.module';
import { WebhookComponent } from './webhook/webhook.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { TransferCommissionComponent } from './transfer-commission/transfer-commission.component';
import {TransferCommissionModule} from './transfer-commission/transfer-commission.module';
import { DollarRateComponent } from './dollar-rate/dollar-rate.component';
import { ApiKeysComponent } from './api-keys/api-keys.component';
import { ReconciliationComponent } from './reconciliation/reconciliation.component';

@NgModule({
    imports: [
        BrowserModule,
        RoutingModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        DashboardModule,
        FundHistoryModule,
        AgentModule,
        AdminModule,
        DollarRateModule,
        TransactionsModule,
        TransferCommissionModule,
        StatModule,
        UiSwitchModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot(),
        NgxPaginationModule,
        AppComponent,
        AgentComponent,
        DashboardComponent,
        // LoginComponent,
        AdminComponent,
        TransactionsComponent,
        NotfoundComponent,
        FundHistoryComponent,
        WebhookComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        TransferCommissionComponent,
        DollarRateComponent,
        ApiKeysComponent,
        ReconciliationComponent,
    ],
    providers: [httpInterceptorProviders],
    bootstrap: [AppComponent]
})
export class AppModule { }
